import { useReactiveVar } from "@apollo/client";
import { memo } from "react";
import { isShowFullScreenLoadingVar } from "~/components/blocks/common/full-screen-loading/store";
import { Loading } from "~/components/blocks/common/loading";

/**
 * 画面全体にローディングを表示するcomponent
 **/
export const FullScreenLoading = memo(() => {
  const isShow = useReactiveVar(isShowFullScreenLoadingVar);
  if (!isShow) return null;
  return <Loading hasOverlay size={80} />;
});
FullScreenLoading.displayName = "FullScreenLoading";
